import styled, { css } from 'styled-components';
import { device } from '../breakpoints';
import { accentGreen, fontWeightRegular, playGrey15, regularWhite } from '../design-tokens';
import { playFontSize } from '../typography/helpers';

export const Navbar = styled.nav`
    position: relative;
    overflow: hidden;
    border-bottom: 1px solid ${playGrey15};

    @media print {
        display: none !important;
    }
`;

const selectedTabStyling = css`
    &:after,
    .no-touchevents &:hover:after {
        transform: translateY(-3px);
    }
`;

export const PlayTabListItemLink = styled.a`
    ${playFontSize(1.8, true)};
    line-height: 1.3;
    position: relative;
    font-weight: ${fontWeightRegular};
    display: inline-block;
    text-decoration: none;
    padding-bottom: 8px;
    margin-right: 20px;
    margin-bottom: 0;
    transition: font-weight 100ms linear, color 100ms linear;
    color: ${regularWhite};
    cursor: pointer;

    @media ${device.GteSmall} {
        ${playFontSize(2)}
        margin-right: 30px;
    }

    &:after {
        content: ' ';
        position: absolute;
        width: 100%;
        bottom: -3px;
        transform: translateY(0);
        left: 0;
        background-color: ${accentGreen};
        height: 3px;
        transition: transform 200ms linear;
    }

    ${(props) => props.isSelected && selectedTabStyling}

    &:hover,
    &:focus {
        outline: none;
        outline-offset: 1px;
        &:after {
            background-color: ${accentGreen};
            transform: translateY(-3px);
        }
    }

    &:active:after,
    &:focus:after {
        background-color: ${accentGreen};
    }

    .no-touchevents &:hover:after {
        transform: translateY(-1px);
    }
`;
